import ModuleLayout from "@/components/admin/ModuleLayout"
import ChangePasswordForm from "@/components/settings/ChangePasswordForm"
import { toastSuccess } from "@/lib/toast"
import { accountTabs } from "./accountTabs"

export default function AccountSecurityPage() {
  return (
    <ModuleLayout
      breadcrumbs={[{ label: "SateLab", to: "/" }, "Mi cuenta"]}
      title="Mi cuenta"
      subtitle="Administra tu perfil, tu contraseña y tus integraciones personales."
      tabs={accountTabs("security")}
      metrics={[]}
    >
      <div className="max-w-md rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 className="text-base font-semibold text-gray-800 dark:text-white/90">Cambiar contraseña</h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Necesitas tu contraseña actual para definir una nueva.
        </p>
        <div className="mt-6">
          <ChangePasswordForm onSuccess={() => toastSuccess("Contraseña actualizada.")} />
        </div>
      </div>
    </ModuleLayout>
  )
}
